export const cookieSessionName = 'amp_SID';
export const cookieDeviceName = 'amp_DID';
export const amplitudeKey = 'a274d9c5c32d4194ad3e525a859e47e3';
